// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Coding, Patient } from '@medplum/fhirtypes';

export const PENDING_INTAKE_TAG: Coding = {
  system: 'http://polarissleep.com/tags',
  code: 'pending-intake',
  display: 'Pending Intake',
};

export function isPendingIntakePatient(patient: Patient | undefined): boolean {
  return (
    patient?.meta?.tag?.some(
      (tag) => tag.system === PENDING_INTAKE_TAG.system && tag.code === PENDING_INTAKE_TAG.code
    ) ?? false
  );
}

export function withPendingIntakeTag(patient: Patient): Patient {
  if (isPendingIntakePatient(patient)) {
    return patient;
  }
  return {
    ...patient,
    meta: {
      ...patient.meta,
      tag: [...(patient.meta?.tag ?? []), PENDING_INTAKE_TAG],
    },
  };
}

export function removePendingIntakeTag(patient: Patient): Patient {
  const tags = (patient.meta?.tag ?? []).filter(
    (tag) => !(tag.system === PENDING_INTAKE_TAG.system && tag.code === PENDING_INTAKE_TAG.code)
  );
  return {
    ...patient,
    meta: {
      ...patient.meta,
      tag: tags.length > 0 ? tags : undefined,
    },
  };
}
